import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../Lib/Layout";
import UserProvider from "../Lib/UserContext";
import QueryProvider from "../Lib/QueryClientProvider";
import ApplicationContainer from "../Application/ApplicationShow";

export default function ApplicationPage({ application }) {
  return (
    <QueryProvider>
      <Layout>
        <UserProvider>
          <Routes>
            <Route
              path="/applications/:slug"
              element={<ApplicationContainer data={application} />}
            />
          </Routes>
        </UserProvider>
      </Layout>
    </QueryProvider>
  );
}